import React, { ReactNode, useEffect } from "react";
import { updateNavigationDetails } from "../shared/utility";
import { useLocation } from "react-router";
interface AuthenticationLayoutProps {
  children: ReactNode;
}

const AuthenticationLayout: React.FC<AuthenticationLayoutProps> = ({
  children,
}) => {
  const location = useLocation();

  /*
    The below code is being implemented to achieve a feature:
    When a user navigates back to the "landing page" from the "product details page",
    the previously selected categories (filters) will be retained in the "Our Best Seller Products" and "New Products" sections.
    Otherwise, the filters will be set to default.
  */
  useEffect(() => {
    updateNavigationDetails(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <div className="w-full">{children}</div>
    </>
  );
};

export default AuthenticationLayout;
